export default "__VITE_ASSET__DQ3Nq6u2__"